import { useField, useFieldState } from 'formular'


const useAgreementCheck = () => {
  const agreement = useField<boolean>({ value: false })
  const { value: isAgreed } = useFieldState(agreement)

  return { agreement, isAgreed }
}

export default useAgreementCheck